import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import CmsGallery from '../components/CmsGallery'
import BookingBanner from '../components/BookingBanner'

export default function HypnosisPage() {
  return (
    <>
      <MetaTags
        title="Hypnose - Trine Rosendal"
        description="Hypnose og hypnoterapi hos Trine Rosendal. Hvert menneske bærer på sin egen historie. Sammen arbejder vi på et dybere plan i trygge og nærværende rammer."
        image="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1027-scaled.jpg"
        canonicalUrl="https://trine-rosendal.dk/hypnose"
      />

      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-8 sm:py-14 space-y-10 sm:space-y-12">
        {/* Header Introduction */}
        <div className="max-w-3xl space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#EEF3E8] px-3.5 py-1 text-xs font-medium text-[#4C5E43]">
            <i className="fa-solid fa-brain text-[11px] text-[#556B48]" aria-hidden="true" />
            <span>Et naturligt og givende redskab</span>
          </div>

          <h1 className="font-serif text-3.5xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D] tracking-tight">
            Hypnose og hypnoterapi
          </h1>
        </div>

        {/* Main Content & Video Facade */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-7 space-y-6">
            <div className="rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-10 shadow-xs space-y-6 text-base sm:text-[17px] text-[#384632] leading-relaxed">
              <div className="space-y-4">
                <p>
                  Når du kommer hos mig, behøver du ikke have styr på det hele på forhånd.
                </p>

                <p>
                  Du behøver heller ikke kunne forklare præcis, hvad der foregår indeni dig, eller være god til at slappe af. Det lærer du undervejs.
                </p>

                <p>
                  Ofte arbejder vi med følelser, der stammer fra den tidlige barndom. De kan være svære at sætte ord på, fordi de ikke altid er blevet bearbejdet med den voksnes forståelse. Derfor kan det være vanskeligt at forklare, hvad du mærker.
                </p>

                <p>
                  Jeg arbejder med hypnose, fordi det kan noget andet end samtalen alene. Når vi forsøger at tale og analysere os gennem en krise eller problemstilling, kan vi komme til at blive i tankerne. På den måde får vi ikke altid kontakt til de grundfølelser, der ubevidst påvirker vores reaktioner og mønstre.
                </p>

                <p>
                  I hypnosen får du mulighed for at mærke og rumme følelserne på en tryg måde. Det kan give en dybere forståelse, som ikke kun bygger på analyse, men også på kroppens og underbevidsthedens viden.
                </p>
              </div>

              {/* Hvad er hypnose? */}
              <div className="pt-4 border-t border-[#E3EDD9] space-y-4">
                <h2 className="font-serif text-2xl font-medium text-[#222E1D]">
                  Hvad er hypnose?
                </h2>
                <p>
                  Hypnose er en naturlig tilstand, hvor du vender opmærksomheden indad.
                </p>
                <p>
                  Du sover ikke og mister ikke kontrollen. Du kan hele tiden høre, hvad jeg siger, og du kan altid sige til eller fra.
                </p>
                <p>
                  Jeg guider dig roligt ind i hypnosen, så kroppen og nervesystemet kan falde mere til ro. Når du slapper af, bliver der bedre plads til at mærke det, der foregår i dig.
                </p>
                <p className="font-medium text-[#222E1D]">
                  Følelser uden tankemæssig modstand er nemmere at slippe. Det er ofte tankerne, der fastholder følelserne.
                </p>
              </div>

              {/* Min intuitive tilgang */}
              <div className="pt-4 border-t border-[#E3EDD9] space-y-4">
                <h2 className="font-serif text-2xl font-medium text-[#222E1D]">
                  Min intuitive tilgang
                </h2>
                <p>
                  Min intuition er et vigtigt værktøj i mit arbejde.
                </p>
                <p>
                  Jeg er trænet i at mærke, hvad der kan ligge bag det, du fortæller, og hvad der dræner dig eller har brug for at blive sluppet.
                </p>
                <p>
                  Ofte kan jeg hurtigt fornemme de grundfølelser, der er med til at skabe de mønstre, som spænder ben for dig. Det er dem, vi arbejder med at rumme og give slip på.
                </p>
              </div>

              {/* Hvad er hypnoterapi? */}
              <div className="pt-4 border-t border-[#E3EDD9] space-y-4">
                <h2 className="font-serif text-2xl font-medium text-[#222E1D]">
                  Hvad er hypnoterapi?
                </h2>
                <p>
                  Hypnoterapi er det terapeutiske arbejde, vi laver under hypnosen.
                </p>
                <p>
                  Vi tager udgangspunkt i det, du gerne vil ændre. Det kan for eksempel være gamle reaktionsmønstre, uro eller manglende kontakt til dine egne behov.
                </p>
                <p>
                  Du behøver ikke fortælle hele din historie eller finde de perfekte ord. Vi arbejder med det, du har brug for lige nu.
                </p>
              </div>

              {/* Du behøver ikke kunne noget på forhånd */}
              <div className="pt-4 border-t border-[#E3EDD9] space-y-4">
                <h2 className="font-serif text-2xl font-medium text-[#222E1D]">
                  Du behøver ikke kunne noget på forhånd
                </h2>
                <p>
                  Du skal ikke kunne slappe af på kommando eller have prøvet hypnose før.
                </p>
                <p>
                  Jeg guider dig gennem hele behandlingen, og du bestemmer altid tempoet. Du er med hele vejen og kan til enhver tid sige til eller fra.
                </p>
                <p>
                  Mit mål er, at du får bedre kontakt til dig selv og bliver mere fortrolig med dine følelser og behov.
                </p>
                <p className="font-medium text-[#222E1D]">
                  At du kan møde dig selv med mere ro, omsorg og tillid.
                </p>
              </div>

              <div className="pt-4 border-t border-[#D6E2CB]">
                <p className="font-semibold text-[#222E1D]">Trine Rosendal</p>
                <p className="text-sm text-[#5C6E52]">Certificeret hypnotisør og hypnoterapeut</p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-2">
              <a
                href="https://system.easypractice.net/book/online-booking-16"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#F5D154] hover:bg-[#EABF35] px-7 py-3.5 text-sm font-semibold text-[#1E2718] shadow-sm transition"
              >
                <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                <span>Book tid til hypnose</span>
              </a>

              <Link
                to="/priser"
                className="inline-flex items-center gap-1.5 rounded-full border border-[#D6E2CB] bg-[#F7F9F3] px-6 py-3.5 text-sm font-medium text-[#222E1D] transition hover:bg-[#EAF1E4]"
              >
                <span>Se priser og forløb</span>
              </Link>
            </div>
          </div>

          {/* Right Column: Information og tryghed */}
          <div className="lg:col-span-5 space-y-4">
            <div className="rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-6 sm:p-7 space-y-4 shadow-xs">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#E2EBD9] text-[#5C7A4F]">
                  <i className="fa-solid fa-sparkles text-sm" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-serif font-medium text-base text-[#222E1D]">En behagelig og naturlig tilstand</h3>
                  <p className="text-xs text-[#5C6E52]">100% tryghed og fuld kontrol</p>
                </div>
              </div>

              <p className="text-xs sm:text-sm text-[#4D5E46] leading-relaxed">
                Hypnose er en fokuseret tilstand af ro og fordybelse – ligesom når du fordyber dig i en god bog eller dagdrømmer. Dit nervesystem falder til ro, og vi kan sammen arbejde direkte med de ubevidste mønstre.
              </p>

              <div className="space-y-2.5 pt-2 border-t border-[#D6E2CB] text-xs text-[#4D5E46]">
                <div className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-[#5C7A4F] mt-0.5" aria-hidden="true" />
                  <span>Du sover ikke og kan ikke manipuleres til noget mod din vilje</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-[#5C7A4F] mt-0.5" aria-hidden="true" />
                  <span>Du kan tale og svare under hele seancen</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="fa-solid fa-check text-[#5C7A4F] mt-0.5" aria-hidden="true" />
                  <span>Behandlingen foregår i rolige og trygge omgivelser i klinikken</span>
                </div>
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-[#DFE6D5] bg-white p-4 text-xs text-[#6F5B6A] space-y-2">
              <p className="font-semibold text-[#2B3824] flex items-center gap-1.5">
                <i className="fa-solid fa-circle-info text-[#556B48]" aria-hidden="true" />
                <span>Værd at vide om hypnose</span>
              </p>
              <p>
                Du er i fuld kontrol under hele forløbet. Det føles behageligt, afslappende og trygt – nærmest som stadiet lige før søvn.
              </p>
            </div>
          </div>
        </div>

        {/* Klinik & Atmosfære CMS Gallery */}
        <div className="border-t border-[#DFE6D5] pt-12 space-y-6">
          <CmsGallery slug="klinik-atmosfaere" />
        </div>

        <BookingBanner />
      </div>
    </>
  )
}
